import { useCallback } from "react";
import { useAuth } from "../AuthContext";

async function readErrorPayload(response) {
  const contentType = response.headers.get("content-type") || "";
  const text = await response.text().catch(() => "");
  if (contentType.includes("application/json")) {
    try {
      return JSON.parse(text || "{}");
    } catch {
      return { message: text };
    }
  }
  return { message: text || response.statusText };
}

const useAuthenticatedFetch = () => {
  const { user } = useAuth();

  return useCallback(async (url, options = {}, passedUser) => {
    const token = passedUser?.token || user?.token;

    if (!token) {
      throw new Error("Utilisateur non authentifié.");
    }

    const headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };

    const response = await fetch(url, { ...options, headers });

    if (!response.ok) {
      const details = await readErrorPayload(response);
      const err = new Error(details?.message || details?.error || `Erreur API : ${response.statusText}`);
      err.status = response.status;
      err.code = details?.code;
      err.details = details;
      throw err;
    }

    return response;
  }, [user?.token]);
};

export default useAuthenticatedFetch;
